(function($) {
    var headshotDownloadTandCOverlayHandler = `
    <div class="headshot-overlay">
            <div class="form-wrap-overlay">
                <div class="v-middle-inner">
                    <div class="v-middle">
                        <div class="form-container">
                            <h3>Image Use Terms and Conditions</h3>
                            <div class="t-and-c-box">
                                <div class="conditions">
                                <p>All images and content on this website are protected by copyright law. By downloading any file from this website including and not limited to fellow headshots, events, programming, and other graphics, you agree to use it only for personal or non-commercial purposes, refrain from modifying or claiming ownership of the file, properly attribute it to the original creator, and assume responsibility for any infringement of copyright or intellectual property rights. Commercial use is strictly prohibited without prior written consent. The Hoover Institution reserves the right to revoke permission at any time. If you do not agree, please refrain from downloading any files from Hoover.org.</p>
                                </div>
                            </div>
                            <div class="declaration"">
                                <p>By clicking "Accept" you acknowledge and agree to our terms and conditions.</p>
                                <p>To request use for commercial purpose <a href="mailto:hoovermarketing@stanford.edu">contact us.</a></p>
                                <div class="btn-wrap">
                                <button class="btn-red accept">Accept</button>
                                <button class="btn-red-border decline">Decline and Go Back</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;

    $(document).ready(function() {
        if ((".content-with-sidebar .content-wrap .text-wrapper .Paragraph").length > 0) {
            $('.content-with-sidebar .content-wrap .text-wrapper p span').contents().unwrap();
            $('.content-with-sidebar .content-wrap .text-wrapper .OutlineElement.Ltr.SCXW256016174.BCX0').contents().unwrap();
            $('.content-with-sidebar .content-wrap .text-wrapper p').each(function() {
                var text = $(this).html();
                if (text === "&nbsp;") {
                    $(this).hide();
                }
            });
        }
        if ((".content-with-sidebar").length > 0) {
            $('.content-with-sidebar .content-wrap .toggleable').prev().addClass('ellipsis');

            $('.content-with-sidebar .content-wrap .text-wrapper p').each(function() {
                    var text = $(this).html();
                    if (text === "&nbsp;") {
                        console.log("69")
                        $(this).remove();
                    }
            });

            var len = $('.content-with-sidebar .content-wrap p').length;
            if (len > 4) {
                $('.content-with-sidebar .content-wrap p', this).eq(3).nextAll().hide().addClass('toggleable');
                $('.content-with-sidebar .content-wrap p', this).eq(2).nextAll().addClass('ellipsis');
            } 
            if (len < 5) {
                $('.content-with-sidebar .content-wrap .btn-wrapper span').hide();
            }
            $('.content-with-sidebar .content-wrap .btn-wrapper span').on('click', function() {
                
                $(this).parents('.content-wrap').find('p.toggleable').slideToggle(function() {
                    if ($(this).is(':visible')) {
                        $('.content-with-sidebar .content-wrap .btn-wrapper span').text("Read Less");
                        $('.content-with-sidebar .content-wrap .toggleable').prev().removeClass('ellipsis');

                    } else {
                        $('.content-with-sidebar .content-wrap .btn-wrapper span').text("Read More");
                        $('.content-with-sidebar .content-wrap .toggleable').prev().addClass('ellipsis');

                    }
                });
            });
            
            if ($(window).width() < 1601) {
                if ($('.header .nav-logo').length > 0) {
                    var off_left = $('.header .nav-logo').offset().left;
                }
                $('.content-with-sidebar .sidebar-wrap .links-wrap').css({ 'padding-left': +off_left });
            }
            //var comp = $('.content-with-sidebar .sidebar-wrap .links-wrap ul li a:not([href*="://"],[target="_blank"],[href^="#"],[href^="mailto:"])');

            $('.content-with-sidebar .sidebar-wrap .links-wrap ul li a').each(function() {
                if (location.hostname === this.hostname || !this.hostname.length) {
                    $(this).addClass('local');
                } else {
                    $(this).addClass('external');
                }
            });

            
            let fellowBody = document.querySelector("body.fellow")
            if(fellowBody){
             handleTandCOverlay()
            }
            
        }
        
          $("#block-hoover-content").on('click', '.algolia-accordion', function () {
            $(this).toggleClass('active-text').find('.algolia-content').slideToggle(500);
            $(this).siblings('.algolia-accordion').removeClass('active-text').find('.algolia-content').slideUp(500);
        });

        function handleTandCOverlay(){
            var getfooterParent = setInterval(() => {
                if($("footer").parent().length > 0){
                    clearInterval(getfooterParent)
                    $("footer").parent().append(headshotDownloadTandCOverlayHandler)
                }
            }, 100);
           var imgPath
            setTimeout(()=>{
                var getHeadshotOverlay = setInterval(() => {
                    if($(".headshot-overlay")){
                        clearInterval(getHeadshotOverlay)
                        imgPath = $(".headshotDownload a").attr('href')
                         $(".headshotDownload a").attr('href',"")
                        $(".content-with-sidebar").on('click', '.headshotDownload', function (e) {
                            e.preventDefault();
                            $(".headshot-overlay").addClass("headshot-active")
                        })
                        
                        $(".decline").on('click', function (e) {
                            e.preventDefault();
                            $(".headshot-overlay").removeClass("headshot-active")
                        })

                        $(".accept").on('click', function (e) {
                            e.preventDefault();
                            $(".headshot-overlay").removeClass("headshot-active")
                            window.location.href = imgPath
                        })
                    }
                   
                }, 100);
            
             },1000)
        }

        function BioOverlay() {
            $(document).on("click", ".content-with-sidebar .bio", function (e) {
                e.preventDefault();
                const $bioContent = $(this).find(".bio-content");
                    if ($(".bio-container .bio-content").text().trim() !== $bioContent.text().trim()) {
                    $(".bio-container .bio-content").remove();
                    $bioContent.clone().appendTo(".bio-container");
                }
                $(".bio-overlay").addClass("bio-overlay-active");
            });
            closeBioOverlay();
        }

        function closeBioOverlay() {
            $(document).on("click", ".bio-overlay .bio-close", function () {
                $(".bio-overlay").removeClass("bio-overlay-active");
            });
            $(document).on("click", ".bio-overlay", function (e) {
                if (!$(e.target).closest(".bio-container").length) {
                    $(".bio-overlay").removeClass("bio-overlay-active");
                }
            });
        }
        BioOverlay();

        $(document).on('click', '.copy-button', function () {
            var $button = $(this);
            var $target = $button.siblings('.bio-wrap');
            var text = $target.text().trim();
        
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(text).then(function () {
                    $button.text('Copied!');
                    setTimeout(function () {
                        $button.text('Copy Bio');
                    }, 2000);
                }).catch(function (err) {
                    console.error('Failed to copy: ', err);
                });
            } else {
                var $temp = $('<textarea>');
                $('body').append($temp);
                $temp.val(text).select();
                document.execCommand('copy');
                $temp.remove();
                $button.text('Copied!');
                setTimeout(function () {
                    $button.text('Copy Bio');
                }, 2000);
            }
        });
        
    });
    

    $(window).on('load resize', function() {
        $('.content-with-sidebar .sidebar-wrap .links-wrap').css({ 'opacity': '1' });
        if ($(window).width() < 1601) {
            if ($(".content-with-sidebar").length > 0) {
                var off_left = $('.header .nav-logo').offset().left;
                $('.content-with-sidebar .sidebar-wrap .links-wrap').css({ 'padding-left': +off_left });
            }
        }
    });

})(jQuery);